import cn from 'classnames';
import * as React from 'react';

import styles from './NavText.module.scss';

interface IProps {
  title: string;
  className?: string;
  inPopover?: boolean;
}

const NavText = ({ title, className, inPopover }: IProps) => (
  <div className={cn(styles.navText, { [styles.popover]: inPopover }, className)}>{title}</div>
);

export default NavText;
